angular.module('app.filters').filter('metricSuffix', ($filter) => {
  'ngInject';
  let numberWithUnitFilter = $filter('numberWithUnit');
  return (number, extraText) => {
    if (!number) return '';
    if (!extraText) extraText = '';
    if (!_.isNumber(number)) return number;

    // Reduce the number to be < 1000
    let tridecadic_reduction = 0;
    while (number >= 1000.0) {
      number = number / 1000.0;
      tridecadic_reduction += 1;
    }

    let prefix;
    switch (tridecadic_reduction) {
      case 0:
        prefix = '';
        break;
      case 1:
        prefix = 'k';
        break;
      case 2:
        prefix = 'M';
        break;
      case 3:
        prefix = 'G';
        break;
      case 4:
        prefix = 'T';
        break;
      case 5:
        prefix = 'P';
        break;
      default:
        prefix = `10^${3 * tridecadic_reduction}`;
    }

    return numberWithUnitFilter(number, 1, prefix + extraText);
  };
});



// WEBPACK FOOTER //
// ./app/filters/metric-suffix.js